// extracted by mini-css-extract-plugin
export default {"capitalize":"cells_capitalize__DG0Gy"};